<template>
  <div class="resolution-ui-wrapper">
    <div v-if="monitorStatus === 'Clear'" class="resolution-ui">
      <v-alert type="success">
        Monitor Status: {{ this.monitorStatus }}</v-alert
      >
      <v-btn depressed color="primary" @click="save(true)">
        Ok
      </v-btn>
    </div>
    <div v-else class="resolution-ui">
      <v-alert type="warning">
        Monitor Status: {{ this.monitorStatus }}</v-alert
      >
      <v-btn depressed color="primary" @click="confirmationDialogOpen = true">
        Continue without a Clear Monitor Status
      </v-btn>
    </div>

    <v-dialog v-model="confirmationDialogOpen" width="672">
      <v-card class="pa-4">
        <v-card-title class="justify-center pt-0">
          <v-icon size="48" color="colorAlertRed">mdi-alert-rhombus</v-icon>
          <v-btn
            icon
            absolute
            top
            right
            @click="confirmationDialogOpen = false"
          >
            <v-icon>mdi-window-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          WARNING: Bypassing may result in approving a vendor with an
          outstanding Exclusion. Are you sure you wish to continue?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="confirmationDialogOpen = false">
            Cancel
          </v-btn>

          <v-btn color="primary" @click="save(false)">
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { get, post } from "@/services/request";
import {
  onboardingMonitorStatusAPI,
  workflowStepStatusUpdateAPI
} from "@/services/api";
import hasNotifications from "@/mixins/has-notifications";

export default {
  name: "MonitorStatusResolutionUI",
  props: ["covgId", "item"],
  mixins: [hasNotifications],
  data() {
    return {
      monitorStatus: "",
      confirmationDialogOpen: false
    };
  },
  created() {
    this.loadMonitorStatus();
  },
  methods: {
    loadMonitorStatus() {
      get(onboardingMonitorStatusAPI.getUrl({ covgId: this.covgId })).then(
        response => {
          if (response && response.data) {
            this.monitorStatus = response.data;
          }
        }
      );
    },
    save(clear) {
      this.confirmationDialogOpen = false;
      post(workflowStepStatusUpdateAPI, {
        itemId: this.item.id,
        status: clear ? "COMPLETE" : "NON_APPLICABLE"
      })
        .then(response => {
          if (response) {
            this.showMessage("Successfully completed monitor status step.");
            this.$router.push("/client/manage/onboard/" + this.covgId);
          }
        })
        .catch(() =>
          this.showMessage({
            text: "Error completing step.",
            mode: "error"
          })
        );
    }
  }
};
</script>

<style scoped></style>
